import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

/**
 * RTU-3 (row 0.99235) — Test-Fit modern decomposition, build-
 * deliverability canonical addition.
 *
 * Cost range estimate (RSMeans Heavy / Building benchmarks +
 * Mortenson / Turner data-centre programme benchmarks) — narrative
 * giving the indicative LOW / TYPICAL / HIGH construction cost range
 * for the layout class identified in the test-fit, expressed in $/MW
 * (against the IT load capacity from directive #9) and $/SF
 * (against the gross data-hall area), decomposed into RSMeans line
 * categories (mass grading, structural shell, MEP rough-in, site
 * utilities). Generated by `buildTestFitNarrative` (directive #11)
 * under the SNT-1 / SNT-4 instruction-shape guard; SNT-5 fallback at
 * `costRangeEstimateFallback` substitutes a data-grounded placeholder
 * when the model returns an empty string.
 */
export const CostRangeEstimateSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.costRangeEstimate;
  const hasData = typeof data === 'string' && data.trim().length > 0;
  return (
    <SectionShell label={label} hasData={hasData}>
      {/* W1c editorial port — the hand-rolled small-caps sub-label + <p>
          becomes an EditorialSubsection (themed label run + prose body).
          GAP: the LOW / TYPICAL / HIGH figures live ONLY inside the generated
          narrative — no structured range fields exist on the report, so no
          Datasheet/DataTable decomposition is possible without parsing free
          text. Render the narrative verbatim; never fabricate range rows. */}
      {hasData && (
        <EditorialSubsection theme={theme} label="RSMeans + Mortenson / Turner Programme Benchmarks">
          {data}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
